export interface ApiError {
  code: string;
  message: string;
  details?: Record<string, unknown>;
  traceId?: string;
}

export function isApiError(x: unknown): x is ApiError {
  return !!x && typeof x === "object" && "code" in x && "message" in x;
}

export function errorMessage(x: unknown, fallback = "请求失败"): string {
  if (isApiError(x)) return x.message;
  if (x instanceof Error) return x.message;
  return fallback;
}

/** Extract field-level validation errors (422) into a flat map. */
export function fieldErrors(x: unknown): Record<string, string> {
  if (!isApiError(x)) return {};
  const fe = x.details?.["fieldErrors"];
  if (fe && typeof fe === "object") return fe as Record<string, string>;
  return {};
}
